/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxUploadArchive } from "../../funcs/sandboxUploadArchive.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UploadWorkspaceArchiveRequest$inboundSchema,
};

export const tool$sandboxUploadArchive: ToolDefinition<typeof args> = {
  name: "sandbox-upload-archive",
  description: `Upload Workspace Archive

Upload a zip archive and extract its files into the session workspace.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxUploadArchive(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
